"use client"

import {useTranslations} from "@/contexts/TranslationContext";
import {MdOutlineReportProblem} from "react-icons/md";
import {cn} from "@/lib/utils";
import {buttonVariants} from "@/components/ui/button";
import {Tooltip} from "@/components/ui/tooltip";
import {useEffect, useState} from "react";
import {usePathname} from "next/navigation";
import Bowser from "bowser";

type UserInfo = {
    browser: string,
    browserVersion: string,
    os: string,
    osVersion: string,
    platform: string,
}

export function ContactButton() {
    const pathname = usePathname();
    const [currentPath, setCurrentPath] = useState<string | null>(null);
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const browser = Bowser.getParser(window.navigator.userAgent);
            setCurrentPath(window.location.href);
            setUserInfo({
                browser: browser.getBrowserName(),
                browserVersion: browser.getBrowserVersion(),
                os: browser.getOSName(),
                osVersion: browser.getOSVersion(),
                platform: browser.getPlatformType()
            })
        }
    }, [pathname]);

    const t = useTranslations();

    const email = "kapi20@kampmann.de";
    const subject = encodeURIComponent(t["userProfile.contact.subject"]);
    const body = encodeURIComponent(`${t["userProfile.contact.describeProblem"]}:\n\n${t["userProfile.contact.pasteLink"]}: ${currentPath}\n\n${t["userProfile.contact.pasteScreenshots"]}:\n\n\nBrowser: ${userInfo?.browser} ${userInfo?.browserVersion}\nOS: ${userInfo?.os} ${userInfo?.osVersion}\nPlatform: ${userInfo?.platform}`);

    return (
        <Tooltip content={t["userProfile.contact.label"]} delay={0}>
            <a href={`mailto:${email}?subject=${subject}&body=${body}`} className={cn("flex w-full justify-between hover:cursor cursor-pointer hover:text-secondary", buttonVariants({ variant: "primary", size: "icon" }))}>
                <MdOutlineReportProblem className={"size-6"} />
            </a>
        </Tooltip>
    )
}